import type { OrderView } from '@khaddi/contracts';

/** "VNPay ✓" → "VNPay": the check mark reads oddly inside "Đã trả …". */
export const paymentName = (order: Pick<OrderView, 'paymentLabel'>): string => order.paymentLabel.replace(/\s*✓\s*$/, '');

export const initialsOf = (name: string): string =>
  name
    .split(/\s+/)
    .filter(Boolean)
    .slice(-2)
    .map((part) => part[0]?.toUpperCase() ?? '')
    .join('') || 'KH';

export const mapsUrl = (address: string): string => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(address)}`;

export const openExternal = (url: string): void => {
  window.open(url, '_blank', 'noopener,noreferrer');
};

const WEEKDAYS = ['CN', 'T2', 'T3', 'T4', 'T5', 'T6', 'T7'];

/** `2026-10-21` → "T4"; parsed at noon so the store's timezone can't shift the day. */
export const weekdayOf = (isoDate: string): string => WEEKDAYS[new Date(`${isoDate}T12:00:00`).getDay()] ?? '';

export const dayMonthOf = (isoDate: string): string => `${isoDate.slice(8, 10)}/${isoDate.slice(5, 7)}`;
